var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1542 7.21531C17.1542 6.85187 16.8337 6.55725 16.4384 6.55725L9.56774 6.55725C9.49871 6.55725 9.43251 6.58246 9.3837 6.62734C9.33489 6.67221 9.30747 6.73308 9.30747 6.79654L9.30747 7.63407C9.30747 7.76623 9.424 7.87337 9.56774 7.87337L14.7105 7.87337L7.34397 14.6463C7.24233 14.7397 7.24233 14.8912 7.34397 14.9847L7.9881 15.5769C8.08974 15.6704 8.25453 15.6704 8.35617 15.5769L15.7227 8.804L15.7227 13.5323C15.7227 13.5958 15.7501 13.6567 15.7989 13.7015C15.8477 13.7464 15.9139 13.7716 15.983 13.7716L16.8939 13.7716C17.0376 13.7716 17.1542 13.6645 17.1542 13.5323L17.1542 7.21531Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.1f7c85e965992eeda1cfd8f65e2a1b69.svg";
export { ForwardRef as ReactComponent };